import { useAuthFetch } from "@/hooks/data/useAuthFetch";
import { companyQueryKeys } from "@/hooks/data/v2/query-keys";
import { APIResponse } from "@simplerealtybits/srb-types";
import { Company } from "@t/Company";
import { useQuery } from "@tanstack/react-query";

export function useGetCompanyById(companyId: number | null) {
    const authFetch = useAuthFetch();

    const getCompanyById = async (id: number | null): Promise<APIResponse<Company>> => {
        if (id === null) throw new Error("Company ID is required");
        return await authFetch(`/api/v1/companies/${id}`).then((response) => response.json());
    };

    const getCompanyByIdQueryOptions = () => ({
        queryKey: companyQueryKeys.getById(companyId),
        queryFn: () => getCompanyById(companyId),
        enabled: !!companyId,
        select: (data: APIResponse<Company>) => data.data,
    });

    return useQuery(getCompanyByIdQueryOptions());
}
